import { defineMessages } from "react-intl";
export var messages = defineMessages({
  currencyFieldAriaLabel: {
    id: "jutro-components.widgets.input.CurrencyField.ariaLabel",
    defaultMessage: "{label} {currency}"
  }
});